<style lang="scss" scoped>
  @import '../../../sass/variables';

  .action-link {
    color: $salesflow-font-gray;
    white-space: nowrap;
  }

  .action-label {
    color: $salesflow-font-gray;
    font-weight: 700;
    line-height: 1rem;
    white-space: nowrap;
    font-size: 0.8125rem;
  }
</style>

<template>
  <div class="d-flex align-items-center">
    <a
      class="action-link ml-4 pt-5px"
      href="#"
      @click.prevent="clone()"
    >
      <IconCopy
        color='#71767D'
        :size="18"
      /><span class="action-label ml-2">{{ __('Clonar') }}</span></a><a
      class="action-link ml-4 pt-5px"
      href="#"
      @click.prevent="openConfig()"
    >
      <IconCog :size="19" /><span class="action-label ml-2">{{ __('Configurações') }}</span></a>
    <button
      class="salesflow-btn salesflow-btn-small salesflow-btn-outline ml-4"
      type="button"
      @click.prevent="stats()"
      @mouseenter="iconBarChartColor = '#FFFFFF'"
      @mouseleave="iconBarChartColor = '#71767D'"
    >
      <IconBarChart :color="iconBarChartColor" class="mt-n1" /><span class="ml-2">{{ __('Ver estatísticas') }}</span>
    </button>
  </div>
</template>

<script>
import { Confirm } from '../../services/Confirm';

export default {
  props: ['user', 'mail'],

  data () {
    return {
      saving: false,
      iconBarChartColor: '#71767D'
    };
  },

  methods: {
    stats () {
      window.location = `/mail/${this.mail.id}/stats`;
    },

    openConfig () {
      Bus.$emit('modalConfigToggled');
    },

    async clone () {
      if (! await Confirm(this.__('Deseja clonar este e-mail? O e-mail clonado irá abrir em uma nova janela.'))) {
        return;
      }

      this.$http.post(`/mail/${this.mail.id}/clone`)
        .then(({ data }) => {
          window.open(`/mail/${data.id}`);
        })
        .catch((error) => console.warn(error));
    },
  },
};
</script>
